import * as info from "info";
import * as ewe from "@eyeo/webext-ad-filtering-solution";
import { getUserId } from "../../../adblock-betafish/id/background/index";
import { License } from "../../../adblock-betafish/picreplacement/check";
import { Prefs } from "../../../adblock-betafish/alias/prefs";
export async function getInjectionInfo() {
    await Prefs.untilLoaded;
    const isPremium = License.isActiveLicense();
    const version = info.addonVersion;
    const id = await getUserId();
    const blockCount = Prefs.get("blocked_total");
    const experimentFlags = await ewe.experiments.getFlags();
    return { isPremium, version, id, blockCount, experimentFlags };
}
